import React, { useState } from "react";
import { motion } from "framer-motion";

// components
import ShowTime from "../ShowTime/ShowTime";
import ComingSoon from "../ComingSoon";

// styles
import styles from "./styles.module.scss";

const Tab = ({ data }) => {
  const [index, setIndex] = useState(1);

  return (
    <div className={styles.tab__wrapper}>
      {/* <motion.div className={styles.tabs}>
        <motion.span
          animate={{
            borderBottomColor: index === 1 ? "#2f80ed" : "#e0e0e0",
            color: index === 1 ? "#2f80ed" : "#828282",
          }}
          transition={{ duration: 0.25, delay: 0.1 }}
          onClick={() => setIndex(1)}
        >
          Coming Soon (0)
        </motion.span>
        <motion.span
          animate={{
            borderBottomColor: index === 2 ? "#2f80ed" : "#e0e0e0",
            color: index === 2 ? "#2f80ed" : "#828282",
          }}
          transition={{ duration: 0.25, delay: 0.1 }}
          onClick={() => setIndex(2)}
        >
          ShowTimes ({data?.Slots ? data?.Slots?.length : 0})
        </motion.span>
      </motion.div>
      <div className={styles.content}>
        {index === 1 ? <ComingSoon /> : <ShowTime data={data} />}
      </div> */}
      <div className={styles.content}>
        <ShowTime data={data} />
      </div>
    </div>
  );
};

export default Tab;
